import React, { Fragment, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getBooks } from '../../Services/BooksServices';
import Loader from '../Main/Loader';
import AppPagination from '../Main/Pagination';
import ProductCard from '../Main/ProductCard';
import { useLocation } from 'react-router-dom';


const BooksList = () => {

    const location = useLocation();
    const bookCategory = location.state
    const [bookType, setBookType] = useState("book")

    const [booksData, setBooksData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [links, setLinks] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalProducts, setTotalProducts] = useState("")
    const [showingProducts, setShowingProducts] = useState("")

    const handlecCurrentPage = (page) => {
        setCurrentPage(page)
    }

    const handleGetBooks = async () => {
        setIsLoading(true)
        let response = await getBooks(bookType)
        if (response.statusCode === 200) {
            setBooksData(response?.response?.data?.data)
            localStorage.setItem("bookData", JSON.stringify(response?.response?.data?.data));
            setLinks(response?.response?.data?.links)
            setTotalProducts(response?.response?.data?.total)
            setShowingProducts(response?.response?.data?.to)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value)
            // }
            toast?.error(response?.errors)

            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const hanldeBooksType = (value) => {
        setBookType(value)
    }

    useEffect(() => {
        handleGetBooks();
    }, [bookType, currentPage])


    useEffect(() => {
        if (bookCategory) {
            setBookType(bookCategory)
        }
    }, [])

    useEffect(() => {
        if (!bookType) return; // Agar bookType empty hai toh API call mat karo
        handleGetBooks();
    }, [bookType, currentPage]); 

    return (
        <Fragment>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-4 mt-5">
                        <div className="card bg-dark px-4 py-5">
                            <h2 className='text-light heading mb-4'>Categories</h2>

                            <button onClick={() => { hanldeBooksType("book") }} className={`${bookType === "book" ? "btn-danger" : "btn-light"} btn mb-3`}>Books</button>
                            <button onClick={() => { hanldeBooksType("audio_book") }} className={`${bookType === "audio_book" ? "btn-danger" : "btn-light"} btn mb-3`}>Audio Books</button>
                        </div>
                    </div>

                    <div className="col-lg-8 my-5">
                        <div className="row  g-3 ">
                            {
                                isLoading ? <Loader /> :
                                    (
                                        <>
                                            {Array.isArray(booksData) && booksData?.length > 0 ? (
                                                booksData?.map((item, i) => {
                                                    return (
                                                        <div className="col-lg-3">
                                                            <>
                                                                <ProductCard
                                                                    key={i}
                                                                    data={item}
                                                                />
                                                            </>
                                                        </div>
                                                    )
                                                })

                                            ) : ("No data Found")}
                                        </>
                                    )
                            }

                        </div>


                        {
                            booksData?.length > 0 && (
                                <div className="col-12">
                                    <AppPagination
                                        links={links}
                                        handlecCurrentPage={handlecCurrentPage}
                                        totalProducts={totalProducts}
                                        showingProducts={showingProducts}
                                    />
                                </div>
                            )
                        }
                    </div>
                </div>


            </div>
        </Fragment >
    )
}

export default BooksList